<template>
  <div :class="['flex flex-col', margin, 'w-full min-w-0']">
    <span class="text-xs font-medium text-slate-700">{{ label }}:</span>

    <!-- min-w-0 es clave para que el truncate funcione dentro de flex -->
    <div class="flex items-center min-w-0">
      <i :class="`bx ${icon} mr-1 shrink-0`"></i>

      <!-- value truncado para que no agrande la columna -->
      <p
        :title="String(value ?? '')"
        class="font-bold text-xs min-w-0 flex-1 truncate"
      >
        {{ value }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoLabel",
  props: {
    label: String,
    value: {
      type: [String, Number],
      default: ""
    },
    icon: String,
    margin: {
      type: String,
      default: "mx-1"
    }
  }
};
</script>